import { defaultCompose } from '@sendible/frontendv2/src/components/MediaSystem/consts';
import SharedStateBridge from '@sendible/shared-state-bridge';

export default () => {
  const newUserData = window.loginContext.getCurrentDetails();
  const oldUserSharedState = SharedStateBridge.getSharedState();

  SharedStateBridge.setItem({
    compose: { ...defaultCompose },
    user: {
      ...oldUserSharedState.user,
      userId: newUserData.id,
      username: newUserData.login,
      email: newUserData.email,
      timezone: -newUserData.timezone, // for some unknown reason the timezone offset is inverted in legacy app
      isPaused: !!newUserData.is_paused,
      isSwitchedUser: !window.loginContext.isLoggedInUserActive(),
      clockFormat: Number(window.loginContext.defaultDetails.clock_format) as 12 | 24,
    },
    app: {
      addThreadsPromptOpenMode: null,
      addTikTokPromptOpenMode: null,
      addingServiceId: null,
      xConnectionModal: {
        isConnectOpen: false,
        accountId: null,
      },
      blueskyConnectionModal: {
        isConnectOpen: false,
        reconnectionAccountId: null,
      },
      mediaPreview: {
        isMediaPreviewOpen: false,
        mediaList: [],
        initialMediaIndex: 0,
      },
      dashboardReloadPending: oldUserSharedState.app?.dashboardReloadPending ?? false,
    },
  });
};
